import { RowExportTypePdf } from "types";
import { PdfTemplate } from "components";
import { ListDepartement } from "../types";

export function PdfDepartment(props: { dataList: ListDepartement[] }) {
  const columns = [
    { header: "NO", key: "no", width: 5 },
    { header: "DIVISI", key: "divisi", width: 10 },
    { header: "DEPARTMENT", key: "department", width: 10 },
    { header: "DESCRIPTION", key: "description", width: 15 },
  ];

  const dataMap: RowExportTypePdf[] = props.dataList.map((item, index) => ({
    no: index + 1,
    divisi: item.divisi_name ?? "-",
    department: item.department_name ?? "-",
    description: item.description ?? "-",
  }));

  return <PdfTemplate data={dataMap} column={columns} title="Department" />;
}
